
import Minus from "../../../assets/filled/Minus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MinusIcon({ className, dataTestid = "MinusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Minus data-testid={dataTestid} className={classes} {...rest} />
  );
}
